import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const benefitsInKindListService = (params: {
  page?: number;
  limit?: number;
  keyword?: string | null;
  status?: number | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<Types.BenefitsInKind>>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const benefitsInKindListShortService = (params: {
  page?: number;
  limit?: number;
  keyword?: string | null;
  status?: number | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<Types.BenefitsInKind>>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      byPassError: true,
      params,
    },
  });

export const benefitsInKindCreateService = (params: {
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
  amount: number;
  status: number;
  pit: boolean;
  pitByCompany: boolean;
  pitByEmployee: boolean;
  glCode: string;
}) =>
  RestAPIClient.call<Types.BenefitsInKind>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const benefitsInKindUpdateService = (
  params: Parameters<typeof benefitsInKindCreateService>[0] & { id: string }
) =>
  RestAPIClient.call<Types.BenefitsInKind>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const benefitsInKindDeleteService = (id: string) =>
  RestAPIClient.call<Types.BenefitsInKind>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const benefitsInKindDetailService = (id: string) =>
  RestAPIClient.call<Types.BenefitsInKind>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });
